import { styled } from '@clickcease/cc-client-components-lib'

export const AddEditUserModalStyled = styled('div', {
  display: 'flex',
  flexDirection: 'column',
  width: '530px',
  height: '290px',
  padding: '$12',
})

export const AddUserModalDescription = styled('div', {
  fontWeight: '$l',
  fontSize: '$md',
  marginBottom: '$10',
})

export const FormRow = styled('div', {
  display: 'flex',
  justifyContent: 'space-between',
  marginBottom: '$10',
})

export const SelectDomainsWrapper = styled('div', {
  display: 'flex',
  flexDirection: 'row',
  gap: '$12',
  width: '100%',
})

export const ErrorStyled = styled('div', {
  color: '$error',
  fontSize: '$md',
  marginTop: '$4',
  fontWeight: '$l',
})
